import { render, staticRenderFns } from "./GoogleAuthButton.vue?vue&type=template&id=98584580&"
import script from "./GoogleAuthButton.vue?vue&type=script&lang=js&"
export * from "./GoogleAuthButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports